module.exports = __webpack_public_path__ + "media/images/icon/payment/ae-card-text-889d1f0731e575e379f46f12b7c55316.svg";